<template>
  <div ref="pdfContainer" style="margin-top:15px;">
    <div v-show="is_show">
      <div style="margin-bottom:15px;">
        <template v-if="cascader_options">
          <el-cascader v-model="selectedFileKey" :options="cascader_options" @change="handleFileChange">
          </el-cascader>
        </template>
        <template v-else>
          <el-select v-model="selectedFileKey" @change="handleFileChange" style="width: 200px;">
            <el-option v-for="(value, key) in fileObject" :value="key" :key="key">
              <div class="custom_option_box" :title="key">文件 {{ key }}</div>
            </el-option>
          </el-select>
        </template>
      </div>
      <template v-if="isVisible && fileSrc">
        <embed :src="fileSrc" style="width:100%;height:600px" />
      </template>
    </div>
  </div>
</template>
<script setup>
  import { ref, defineProps, watch, onBeforeMount, onMounted, onBeforeUpdate, onUpdated, onBeforeUnmount, onUnmounted, defineEmits } from 'vue';
  import PubSub from 'pubsub-js';
  import { defaultFullRequestMethodGet } from '@/api/index.js';
  import { transformToCascaderData } from '@/utils/tool.js';

  const emit = defineEmits([])
  const props = defineProps(['node_data', 'pdf_files']);


  const is_show = ref(false);
  const fileObject = ref({});// 存储文件对象
  const selectedFileKey = ref('');// 当前选择的文件键
  const fileSrc = ref('');// 当前显示的文件
  const cascader_options = ref(null);
  const isVisible = ref(false);// PDF 是否进入视口
  const node_data_token = ref(null);// 节点数据token
  const pdfContainer = ref(null);// PDF 容器

  const observer = new IntersectionObserver(([entry]) => {
    if (entry.isIntersecting) { // 进入视口
      isVisible.value = true;
      if (selectedFileKey.value) {
        fetchFileData(fileObject.value[selectedFileKey.value]); // 触发 PDF 加载
      };
      observer.disconnect(); // 只触发一次，避免重复监听
    };
  }, { threshold: 0.1 });// 监听 PDF 容器

  const initPdf = function (filePaths) {
    selectedFileKey.value = Object.keys(filePaths)[0];
    fileObject.value = filePaths;
    // **不主动加载 PDF**，等待组件进入视口后再加载
    if (isVisible.value) {
      fetchFileData(filePaths[selectedFileKey.value]);
    }
  };

  const handleFileChange = function (val) {
    let newFileSource = null;
    if (Array.isArray(val)) {
      let s_val = val.join('_');
      newFileSource = fileObject.value[s_val];
    } else if (typeof val === 'string') {
      newFileSource = fileObject.value[val];
    };
    if (newFileSource) fetchFileData(newFileSource);
  };

  const fetchFileData = function (fileSource) {
    const base64Pattern = /^data:([a-zA-Z0-9]+\/[a-zA-Z0-9-.+]+);base64,/;
    const localPathPattern = /^\./;
    if (base64Pattern.test(fileSource) || localPathPattern.test(fileSource)) { // 本地文件或base64数据
      fileSrc.value = fileSource;
    } else { // 远程文件
      const url = process.env.VUE_APP_BASE_API + fileSource;
      defaultFullRequestMethodGet(url, {}).then((blob) => {
        fileSrc.value = URL.createObjectURL(blob);
      }).catch((error) => {
        console.error('pdf文件加载失败:', error);
      });
    };
  };


  // 使用 watch 监听 props 的字段变化
  watch(() => props, (newData, oldData) => {
  });
  //组件即将挂载
  onBeforeMount(() => {
  });
  //组件已经挂载
  onMounted(() => {
    observer.observe(pdfContainer.value);// 监听 PDF 容器
    node_data_token.value = PubSub.subscribe(`files_${props.node_data.title}`, function (msg, data) { // 节点数据
      if (data.pdfFiles && data.pdfFiles.pdfFiles) {
        is_show.value = true;
        cascader_options.value = data.pdfFiles.select_data
          ? transformToCascaderData(data.pdfFiles.select_data)
          : null;
        initPdf(data.pdfFiles.pdfFiles);
      } else {
        is_show.value = false;
      }
    });

  });
  //组件即将更新
  onBeforeUpdate(() => {
  });
  //组件已经更新
  onUpdated(() => {
  });
  //组件即将卸载
  onBeforeUnmount(() => {
    if (node_data_token.value) PubSub.unsubscribe(node_data_token.value); // 取消节点数据监听
    if (observer) observer.disconnect();// 停止监听 PDF 容器
  });
  //组件已经卸载
  onUnmounted(() => {
  });
</script>
<style scoped>
  .custom_option_box {
    max-width: 200px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
</style>